
class DateTimeHelper {
  constructor() {
  }

  toLocalDateShort() {
    const elsToConvert = document.querySelectorAll('[data-date]');
    elsToConvert.forEach(element => {
      const localDate = new Date(element.getAttribute('data-date'));
      const dateFormat = {
        day: 'numeric',
        month: 'short'
      };
      let date = localDate.toLocaleString(document.documentElement.lang, dateFormat).split(' ');
      element.innerHTML = `${date[1]} ${date[0]}`;
    });
  }

  toLocalDate() {
    const elsToConvert = document.querySelectorAll('[data-date]');
    elsToConvert.forEach(element => {
      const localDate = new Date(element.getAttribute('data-date'));
      const dateFormat = {
        year: 'numeric',
        day: 'numeric',
        month: 'short'
      };
      let date = localDate.toLocaleString(document.documentElement.lang, dateFormat).split(' ');
      element.innerHTML = `${date[1].replace(/[^0-9]/g, '')} ${date[0]} ${date[2]}`;
    });
  }

  toLocalDateLong(el, dateToConvert) {
    const dateFormat = {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    };
    const theElement = document.getElementById(el);
    const localDate = new Date(dateToConvert);

    if (document.documentElement.lang == 'es') {
      var months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
        'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      theElement.innerHTML = `${localDate.getDate()} ${months[localDate.getMonth()]} ${localDate.getFullYear()}`;
    } else {
      let date = localDate.toLocaleString(document.documentElement.lang, dateFormat).split(' ');
      theElement.innerHTML = `${date[1].replace(/[^0-9]/g, '')} ${date[0]} ${date[2]}`;
    }
  }
}

export default DateTimeHelper;
